<div class="layout-container" [class.modal-mode]="isModal">
  <!-- Regular header (non-modal) -->
  <div class="header" *ngIf="!isModal">
    <h2>{{ isEditMode ? 'Edit Layout' : 'Add Layout' }}</h2>
    <div class="action-buttons">
      <button mat-button (click)="cancel()">Cancel</button>
      <button mat-raised-button color="primary" [disabled]="!layoutForm.valid" (click)="onSubmit()">Save</button>
    </div>
  </div>

  <!-- Modal header -->
  <div class="modal-header" *ngIf="isModal">
    <h2 class="modal-title">{{ isEditMode ? 'Edit Layout' : 'Create Layout' }}</h2>
    <button mat-icon-button class="modal-close-button" (click)="cancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Content wrapper -->
  <div class="content" [class.modal-content-wrapper]="isModal">
    <form [formGroup]="layoutForm">
      <div class="row">
        <div class="col-lg-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Name</mat-label>
            <input matInput formControlName="name" />
            
            @if (layoutForm.get('name')?.hasError('required') && 
                !layoutForm.get('name')?.errors?.['nameNotUnique']) {
              <mat-error>Name is required</mat-error>
            } 
            @if (layoutForm.get('name')?.errors?.['nameNotUnique']) {
              <mat-error>Layout already exists</mat-error>
            }
          </mat-form-field>
        </div>
      </div>
      <app-email-editor #emailEditor></app-email-editor>
    </form>
  </div>

  <!-- Modal buttons -->
  <div class="modal-actions" *ngIf="isModal">
    <button mat-button class="modal-cancel-button" type="button" (click)="cancel()">
      Cancel
    </button>
    <button mat-raised-button color="primary" class="modal-save-button" type="button"
      [disabled]="!layoutForm.valid" (click)="onSubmit()">
      {{ isEditMode ? 'Update' : 'Save' }}
    </button>
  </div>
</div>